export default __webpack_public_path__ + "static/media/031-cat.fa66f31c.svg";